import type {Address, AddressModelComLib} from '~/gen/openapi/portalService';

export default function formatAddress(address: AddressModelComLib | Address): string {
	const {Line1, Line2, City, PostalCode} = address;
	const postalAndCity = `${PostalCode ?? ''} ${City ?? ''}`.trim()
	return `${Line1}${Line2 != null && Line2.length ? (`, ${Line2}`) : ''}${postalAndCity ? (`, ${postalAndCity}`) : ''}`;
}
